import { useContext } from "react";
import { AuthContext } from "@/context/auth/AuthContext";
import { AuthContextType } from "@/context/auth/AuthTypes";

/**
 * Custom hook to access the authentication context
 * @returns AuthContextType with authentication state and methods
 * @throws Error if used outside of AuthProvider
 */
export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }

  return context;
};
